import '../style/css/Home.css';
import { useTranslation } from 'react-i18next';
import { Section } from 'react-scroll-section';
import Vector1 from '../assets/vector1.svg';
import Vector2 from '../assets/vector2.svg';
import Vector3 from "../assets/vector3.png"
import Idea from '../assets/idea.svg';
import Internet from '../assets/internet.svg';
import Code from '../assets/code.svg';
import { motion } from 'framer-motion';
import TypewriterComponent from 'typewriter-effect';
import FloatingDiv from './FloatingDiv';

function Home() {
  const { t } = useTranslation(['common']);

  const blur = {
    hidden: {
      opacity: 0,
      filter: "blur(10px)"
    },
  
    visible: {
      opacity: 1,
      filter: "blur(0px)",
      transition: { type: "tween", duration: 2}
    }
  };

  return (
    <Section id='home' style={{ width: '100%' }}>
      <div className='container h-container'>
        {/* -------------- Vectors --------------- */}

        <motion.img
          initial={{
            x: '40%',
            y: '-30%',
          }}
          whileInView={{
            x: '20%',
            y: 0,
          }}
          transition={{ duration: 1 }}
          className='vector1'
          src={Vector1}
        />

        <motion.img
          initial={{
            x: '-50%',
            y: '-80%',
            rotate: 60,
          }}
          whileInView={{
            x: '-40%',
            y: '-63%',
          }}
          transition={{ duration: 0.4 }}
          className='vector2'
          src={Vector2}
        />

          <motion.img
          initial={{
            y: '-50%',
          
          }}
          whileInView={{
            y: 0
          }}
          transition={{ duration: 0.4 }}
          className='vector3'
          src={Vector3}
        />

        {/* -------------- Intro --------------- */}

        <motion.div
        className='intro'
        transition={{
          type: 'spring',
          stiffness: 80,
          when: 'beforeChildren'
        }}
        initial={{
          y: '-20%',
        }}
        whileInView={{
          y: 0,
        }}
      >
        <motion.div
          variants={blur}
          initial="hidden"
          whileInView="visible"
          
        >{t('dev')}</motion.div>
        <motion.div
          initial={{
            opacity: 0,
          }}
          whileInView={{
            opacity: 1,
          }}
          transition={{ duration: 2 }}
        >
          <TypewriterComponent className="typewriter"
            options={{
              strings: [t('elegant'), t('intuitive'), t('efficient')],
              autoStart: true,
              delay: 'natural',
              deleteSpeed: 'natural',
              loop: true,
            }}
          />
        </motion.div>
        <motion.div
          initial={{x: "100%", opacity: 0}}
          whileInView={{x: 0, opacity: 1}}
          transition={{delay: 1}}
          >{t('portfolio')}</motion.div>
        
      </motion.div>


        {/* -------------- Floating div --------------- */}
        <motion.div
        className='floatingContainer'
        transition={{
          type: 'spring',
          stiffness: 80,
          delay: .3,
          when: 'beforeChildren',
        }}
        initial={{
          x: '100%',
          y: '-30%',
        }}
        whileInView={{
          x: '80%',
          y: '50%',
        }}
      >
        <FloatingDiv img={Internet} />
      </motion.div>

      <motion.div
        className='floatingContainer'
        transition={{
          type: 'spring',
          stiffness: 80,
          delay: 1.5,
          when: 'beforeChildren',
        }}
        initial={{
          x: '100%',
          y: '0%',
        }}
        whileInView={{
          x: '75%',
          y: '140%',
        }}
      >
        <FloatingDiv img={Code} />
      </motion.div>
      <motion.div
        className='floatingContainer'
        transition={{
          type: 'spring',
          stiffness: 80,
          delay: 2,
          when: 'beforeChildren',
        }}
        initial={{
          x: '100%',
          y: '0%',
        }}
        whileInView={{
          x: '90%',
          y: '160%',
        }}
      >
        <FloatingDiv img={Idea} />
      </motion.div>



      </div>
    </Section>
  );
}

export default Home;
